module.exports = __webpack_public_path__ + "static/thumb-6c4f30269f9a339dcc1fe7d0f6c11b17.png";